import { Link } from "react-router-dom";
import { Logo } from "@/components/Navbar";
import { DISCLAIMER } from "@/data/site";

export function Footer() {
  return (
    <footer className="bg-navy text-white/70" data-testid="footer">
      <div className="mx-auto max-w-7xl px-6 py-16 md:px-10">
        <div className="grid gap-12 md:grid-cols-4">
          <div className="md:col-span-1">
            <Logo light />
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-white/60">
              Independent lab testing for supplements. Know what's actually inside.
            </p>
            <span className="mt-5 inline-flex rounded-md bg-crimson px-3.5 py-1.5 text-xs font-bold text-white">
              100% Independent — No brand affiliations
            </span>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-white">Explore</h4>
            <ul className="mt-4 space-y-3 text-sm">
              <li><Link to="/how-it-works" className="hover:text-white">How It Works</Link></li>
              <li><Link to="/pricing" className="hover:text-white">Pricing</Link></li>
              <li><Link to="/our-testing" className="hover:text-white">Our Testing</Link></li>
              <li><Link to="/testing-technology" className="hover:text-white">Testing Technology</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-white">Company</h4>
            <ul className="mt-4 space-y-3 text-sm">
              <li><Link to="/about" className="hover:text-white">About Us</Link></li>
              <li><Link to="/why-trust-us" className="hover:text-white">Why Trust Us</Link></li>
              <li><Link to="/sample-report" className="hover:text-white">Sample Report</Link></li>
              <li><Link to="/faq" className="hover:text-white">FAQ</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-white">Get Started</h4>
            <ul className="mt-4 space-y-3 text-sm">
              <li><Link to="/login" className="hover:text-white">Log in</Link></li>
              <li><Link to="/register" className="hover:text-white">Create account</Link></li>
              <li><Link to="/pricing" className="hover:text-white">Order a test</Link></li>
            </ul>
          </div>
        </div>
        <div className="mt-12 border-t border-white/10 pt-8">
          <p className="text-xs leading-relaxed text-white/50">{DISCLAIMER}</p>
          <p className="mt-3 text-xs text-white/50">© {new Date().getFullYear()} TestMySupps. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
